// cspell:disable
import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type ShopifyListingId = ID<"shopifyListing">;
export const shopifyListingIdFormat = idFormat<ShopifyListingId>({
  prefix: "sfl_",
});

export type ShopifyPublicationId = ID<"shopifyPublication">;
export const shopifyPublicationIdFormat = idFormat<ShopifyPublicationId>({
  prefix: "spub_",
});

export type ChatGptListingId = ID<"chatGptListing">;
export const chatGptListingIdFormat = idFormat<ChatGptListingId>({
  prefix: "cgpl_",
});

export type RedoMarketplaceListingId = ID<"redoMarketplaceListing">;
export const redoMarketplaceListingIdFormat =
  idFormat<RedoMarketplaceListingId>({ prefix: "rml_" });

export type EbayListingId = ID<"ebayListing">;
export const ebayListingIdFormat = idFormat<EbayListingId>({ prefix: "ebl_" });

export type EbayProductListingId = ID<"ebayProductListing">;
export const ebayProductListingIdFormat = idFormat<EbayProductListingId>({
  prefix: "epl_",
});

export type GoogleShoppingListingId = ID<"googleShoppingListing">;
export const googleShoppingListingIdFormat = idFormat<GoogleShoppingListingId>({
  prefix: "gsl_",
});

export type PriceBookId = ID<"priceBook">;
export const priceBookIdFormat = idFormat<PriceBookId>({ prefix: "pb_" });

export type PriceBookEntryId = ID<"priceBookEntry">;
export const priceBookEntryIdFormat = idFormat<PriceBookEntryId>({
  prefix: "pbe_",
});

export type RedoSuppliesAccountPriceBookId = ID<"redoSuppliesAccountPriceBook">;
export const redoSuppliesAccountPriceBookIdFormat =
  idFormat<RedoSuppliesAccountPriceBookId>({ prefix: "rsapb_" });

export type RedoCartId = ID<"redoCart">;
export const redoCartIdFormat = idFormat<RedoCartId>({ prefix: "rcart_" });

export type RedoCartItemId = ID<"redoCartItem">;
export const redoCartItemIdFormat = idFormat<RedoCartItemId>({
  prefix: "rci_",
});

export type RedoCartCheckoutId = ID<"redoCartCheckout">;
export const redoCartCheckoutIdFormat = idFormat<RedoCartCheckoutId>({
  prefix: "rcc_",
});

export type SuppliesProductMappingId = ID<"suppliesProductMapping">;
export const suppliesProductMappingIdFormat =
  idFormat<SuppliesProductMappingId>({ prefix: "spm_" });

export type SuppliesInventoryConfigId = ID<"suppliesInventoryConfig">;
export const suppliesInventoryConfigIdFormat =
  idFormat<SuppliesInventoryConfigId>({ prefix: "sic_" });

export type SuppliesInventoryReorderId = ID<"suppliesInventoryReorder">;
export const suppliesInventoryReorderIdFormat =
  idFormat<SuppliesInventoryReorderId>({ prefix: "sir_" });

export type SuppliesSubscriptionId = ID<"suppliesSubscription">;
export const suppliesSubscriptionIdFormat = idFormat<SuppliesSubscriptionId>({
  prefix: "ssb_",
});

export type SuppliesSubscriptionOrderId = ID<"suppliesSubscriptionOrder">;
export const suppliesSubscriptionOrderIdFormat =
  idFormat<SuppliesSubscriptionOrderId>({ prefix: "ssbo_" });

export type SuppliesTrackableProductId = ID<"suppliesTrackableProduct">;
export const suppliesTrackableProductIdFormat =
  idFormat<SuppliesTrackableProductId>({ prefix: "stp_" });

export type SuppliesCollectionId = ID<"suppliesCollection">;
export const suppliesCollectionIdFormat = idFormat<SuppliesCollectionId>({
  prefix: "scl_",
});
